<script>
import BaseButton from '@/components/lavender/v2/BaseButton.vue'

export default {
  name: 'AdsPostpaidPaymentFailure',
  components: {
    BaseButton,
  },
}
</script>

<template>
  <div class="ads-postpaid-payment-failure">
    <div class="icon-container error-icon">
      <svg-icon
        color="var(--error-intense)"
        icon-class="warning-circle-colorless"
      />
    </div>
    <h1>{{ $t('ads_payment_failed') }}</h1>
    <p>{{ $t('ads_payment_failed_msg') }}</p>
    <div class="flex gap-2 mt-8 w-full">
      <BaseButton
        type="tertiary"
        class="flex-1"
        track-id="ads_postpaid_failure_maybe_later"
        @click="$router.replace('/ads/postpaid/invoice/')"
      >
        {{ $t('ads_maybe_later') }}
      </BaseButton>
      <BaseButton
        type="primary"
        class="flex-1"
        track-id="ads_postpaid_failure_try_again"
        @click="$router.go('-1')"
      >
        {{ $t('ads_postpaid_try_again') }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ads-postpaid-payment-failure {
  display: contents;

  h1 {
    font-size: 28px;
  }

  .error-icon {
    background: var(--error-subtle);
  }

  p {
    margin-top: 8px;
    color: var(--content-mid);
  }
}
</style>
